module.exports = __webpack_public_path__ + "img/hr-ccm-universal-04b-base-shadow-sequence.f6e28124.png";